import React from 'react';
import { get, noop } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// local dependencies
import { authFlowMemberVerificationMemberSearchWidget as AuthFlowMemberVerificationMemberSearchWidget } from 'ui/views/widgets/authFlowMemberVerificationMemberSearchWidget';
import { AuthFlowMemberVerificationMemberSearchService } from 'services/authFlowMemberVerificationMemberSearch';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { REDUCER, MEMBER_SEARCH_VERIFICATION_MODULE } from 'constants/entity-names';
import { addVerifiedMember } from 'store/actions/callState';
import { isInbound } from 'resolvers/callStateEntities';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import { withRouter } from 'react-router-dom';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AuthFlowMemberVerificationMemberSearch } from 'ui/containers/AuthFlowMemberVerificationMemberSearch';
 *
 * // render
 * <AuthFlowMemberVerificationMemberSearch propName='propValue'/>
 */
export class _AuthFlowMemberVerificationMemberSearch extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            requestPayload: {},
            callState:undefined
        };

        // create service instance
        this.authFlowMemberVerificationMemberSearchService = new AuthFlowMemberVerificationMemberSearchService();
        
        // start data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'AuthFlowMemberVerificationMemberSearch.fetchComponentData()' );

        // cancel ongoing request
        this.authFlowMemberVerificationMemberSearchService.cancel();

        // fetch component data
        const { status, data } = await this.authFlowMemberVerificationMemberSearchService.fetchComponentData( {
            url: this.props.widget.url,
        } );

        // get callType from store
        const module = isInbound() ? MEMBER_SEARCH_VERIFICATION_MODULE.CALLER_VERIFICATION: MEMBER_SEARCH_VERIFICATION_MODULE.CALLEE_VERIFICATION;

        // set requestPayload for table widget
        const requestPayload = {
            context: {
                module: module
            }
        };

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
                requestPayload: requestPayload,
                callState:this.props.callState
            } );
        }
    }

    /**
     * @desc Action handler for column action
     */
    handleActionClick( { type = 'column', item = {}, value = {} } = {} ) {
        log.debug( 'AuthFlowMemberVerificationMemberSearch.handleActionClick()' );

        // get member id
        const memberId = get( item, 'id', null );
        const patientId = get( item, 'values.patientId', null );

        // when `memberId` is clicked, redirect to member detail page ( on OB call to pharmacy verification step has been removed : 41875 )
       // if( 'column' === type && 'memberId' === value.name && get( this.state, 'componentData.data.skipMemberVerificationStep', false ) ) {
       if( 'column' === type && 'memberId' === value.name && get( this.state, 'componentData.data.skipMemberVerificationStep', false ) ) {
            this.props.history.push( {

                pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,

                state: { memberId: memberId, patientId: patientId }

            } );

        }
         // when `memberId` column action is clicked, execute selection callback

         if( 'column' === type && 'memberId' === value.name ) {

            this.props.onMemberSelection( { memberId,patientId } );

        }
    }

     /**
     * @desc Request backend to register `member` as the caller for the ongoing inbound call.
     */
    async registerInboundCaller( { /*url, payload,*/ currentMemberId } ) {
        log.debug( 'AuthFlowMemberVerificationMemberSearch.registerInboundCaller()' );

        // update call state
        this.props.addVerifiedMember( currentMemberId );

        // set current member id
        this.props.updateCurrentMemberId( { currentMemberId: currentMemberId } );

        // mark that member is verified
        this.props.onMarkVerified( { isMemberVerified: false, isMemberSelected: true, isSearchVisibleForMember: this.props.processStatus.isSearchVisibleForMember } );
    }

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.authFlowMemberVerificationMemberSearchService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AuthFlowMemberVerificationMemberSearchWidget
                className={ this.props.className }
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                onActionClick={ this.handleActionClick }
                requestPayload= { this.state.requestPayload }
                callState={ this.props.callState }
            />
        );
    }
}

// set display name
_AuthFlowMemberVerificationMemberSearch.displayName = '_AuthFlowMemberVerificationMemberSearch';

// set default props
_AuthFlowMemberVerificationMemberSearch.defaultProps = {
    onMemberSelection: noop,
};

// prop types
_AuthFlowMemberVerificationMemberSearch.propTypes = {};

/*************************************************/

// map state to props
const mapStateToProps = ( state ) => {
    return {
        callState: state[ REDUCER.CALL_STATE ]
    };
};

// map dispatch to props
const mapDispatchToProps = ( dispatch ) => {
    return {
        addVerifiedMember: bindActionCreators( addVerifiedMember, dispatch ),
    };
};

// return component with acccess to Redux store
export const AuthFlowMemberVerificationMemberSearch = withRouter( connect( mapStateToProps, mapDispatchToProps )( _AuthFlowMemberVerificationMemberSearch ) );
